import React from "react";

import { BIAnnualTestSchema, BIAnnaulTestSchemaInfo } from "./BIAnnaulTestSchema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
const masterKey = [
  {
    key: "C",
    value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance.",
  },
  {
    key: "A",
    value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance.",
  },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  {
    key: "NC",
    value: "Needs Correction.",
  },
  {
    key: "N/A",
    value: "Not Applicable",
  },
];

const BIAnnualTestReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "sdmtsSDTIBiAnnualSubstationTest",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};

const ViewReport = (props) => {
  const { data, completeAsset } = props;
  const { decodedData } = data;
  let subId = getSubStationIdFromAsset(completeAsset);
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Inspection Report - Switch Tests & Inspections" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} data={{ ...data, substationId: subId || " " }} />
      <ReportFraConditionsMasterKey masterKey={masterKey} />

      <div>
        <span className="spacer"></span>
        <table className="table-bordered">
          {BIAnnualTestSchema.map((section, key) => (
            <ReportTableSectionRenderer key={key} section={section} rowsData={decodedData[0].summary} />
          ))}
        </table>
        <table className="table-bordered">
          {BIAnnaulTestSchemaInfo.map((section, key) => (
            <ReportTableSectionRenderer key={key} section={section} rowsData={decodedData[0].summary} />
          ))}
        </table>
        {/* {decodedData.map((singleReport, index) => (
        <div key={index}>
          <span className="spacer"></span>
          <table className="table-bordered">
            {BIAnnualTestReport.map((section, key) => (
              <ReportTableSectionRenderer
                key={key}
                section={section}
                rowsData={singleReport.summary}
              />
            ))}
          </table>
          
        </div>
      ))} */}
      </div>
    </div>
  );
};

export default BIAnnualTestReport;

function getSubStationIdFromAsset(asset) {
  let substationId = asset && asset.attributes["Substation ID"];
  return substationId;
}



// WEBPACK FOOTER //
// ./src/components/Reports/SDMTS/BIAnnualTest/index.jsx